//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;
import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function() {
  // .header-btnがクリックされたときの処理
  $(".header-btn").click(function () {
    // .header-btnと.header-spのopenクラスをトグル（追加/削除）
    $(".header-btn, .header-sp").toggleClass("open");
  });

  // .header-sp内のaタグがクリックされたときの処理
  $(".header-sp a").click(function () {
    // .header-btnと.header-spからopenクラスを削除
    $(".header-btn, .header-sp").removeClass("open");
  });
});

const swiper = new Swiper(".mySwiper1", {
  loop: true,
  slidesPerView: 2.2,
  loopedSlides: 2.2,
  speed: 8000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  allowTouchMove: false,
  breakpoints: {
    769: {
      slidesPerView: 5.5,
      loopedSlides: 5.5,
    },
  },
});

const swiper = new Swiper(".mySwiper2", {
  loop: true,
  loopedSlides: 2.2,
  slidesPerView: 2.2,
  speed: 8000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  allowTouchMove: false,
  breakpoints: {
    769: {
      slidesPerView: 5.5,
      loopedSlides: 5.5,
    },
  },
});

const swiperThumbnail = new Swiper(".swiperThumbnail", {
  slidesPerView: 3,
  spaceBetween: 10,
  slideToClickedSlide: true,
  allowTouchMove: false,
  breakpoints: {
    768: {
      spaceBetween: 25,
    },
  },
});

const swiperMain = new Swiper(".swiperMain", {
  effect: "fade",
  fadeEffect: {
    crossFade: true, // ← フェード間の重なりを滑らかに
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiperThumbnail,
  },
});